const API_PREFIX = 'pgmei'

export default {
  paged: (page, pageSize) => `${API_PREFIX}/paged?pagina=${page}&tamanhoPagina=${pageSize}`,
  url: id => `${API_PREFIX}/${id}/url`,
  observacoes: id => `${API_PREFIX}/${id}/observacao`,
  removerObservacao: id => `${API_PREFIX}/observacao/${id}/remover`,
  salvarObservacao: `${API_PREFIX}/observacao/salvar`,
  baixaLotes: nomeArquivo => `${API_PREFIX}/baixa-lotes?nomeArquivo=${nomeArquivo}`,
  baixaExcel: tipo => `${API_PREFIX}/${tipo}/baixa-excel`,
  historico: id => `${API_PREFIX}/historico?empresaId=${id}`,
  allPaged: `${API_PREFIX}/all-paged`,
}
